//  缓存key，防止多次点击，后端没有拦截，前端处理下
export const CARRIER_KEY = 'CARRIER_KEY_';
